module.exports = __webpack_public_path__ + "static/media/bat4.9f45a539.png";